// export const REST_API_URL = "https://api.backend.halper.ai/api"; //prod
export const REST_API_URL = "https://dev.halper.ai/api"; //dev
// export const REST_API_URL = "https://gevgor.ngrok.pro/api"; //ngrok